export default class ScrollWatch {
	constructor(options) {
		this.target = options.target; // ターゲット要素
		this.scrollThreshold = options.scrollThreshold; // スクロールの閾値
		this.scrolledClass = options.scrolledClass; // スクロール時に付与するクラス名
		this.throttledCheckScroll = this.throttle(this.checkScroll.bind(this), 100); // スクロール監視処理のスロットリング

		window.addEventListener('scroll', this.throttledCheckScroll, { passive: true }); // スクロールイベントを監視
		this.checkScroll(); // 初期表示時にスクロール監視処理を実行
	}

	// スロットリング処理
	throttle(func, delay) {
		let waiting = false; // 実行待ちかどうかのフラグ
		// スロットリング関数を返す
		return (...args) => {
			// 実行待ちの場合は処理を中断
			if (!waiting) {
				// requestAnimationFrameで遅延実行
				requestAnimationFrame(() => {
					setTimeout(() => {
						func(...args); // 遅延実行
						waiting = false; // 待ち状態を解除
					}, delay);
				});
				waiting = true; // 実行待ち状態にする
			}
		};
	}

	// スクロール監視処理
	checkScroll() {
		const scrollY = window.scrollY; // スクロール量を取得
		const isScrolled = scrollY >= this.scrollThreshold; // スクロール量が閾値を超えているかどうかを判定
		this.target.classList.toggle(this.scrolledClass, isScrolled); // ターゲット要素にクラスを付与
	}
}